<template>
  <div>{{ActDescBtn}}
    <table style="position: absolute;" width="100%" :height="this.windowSize.height-8"
      :max-height="this.windowSize.height-8">
      <!-- ContenidoBase-Cotizacion Basica -->
      <tr max-height="48px" height="48px">

        <ContenidoBase :titulo="'Cotización'" :descripcion="'Crear, Modificar y Desactivar Cotización'"
          :EstadoBtn="EstadoBtn" @abrirBarraTablaDinamica="abrirTabla" @MethodNuevo="newwnuevo" @MethodGuardar="save"
          @MethodEliminar="remove" @MethodAnular="anular" @MethodImprimir="imprimirList" />
      </tr>
      <!-- fn ContenidoBase-Cotizacion Basica -->


      <tr>
        <!-- BarraPrimaria-Cotizacion Basica  --------------------------------------------------------------------------------->
        <td width="109" :max-height="this.windowSize.height-96" v-show="BarraPrimariaAbrir">

          <div class="overflow-y-auto "
            v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <!--------------------- aqui va la otra tabla izquierda --------->
                <!-- <v-navigation-drawer >  -->
                <center>
                  <v-btn-toggle>
                    <v-btn small color="yellow accent-4" @click.prevent="actualiza_tb_ver">
                      <i style="font-size: 25px;" class="fa fa-eye"></i> ver
                    </v-btn>



                    <v-btn color="teal darken-2" dark text small
                      @click.prevent="dialogFiltros = true, ObjTemTbDinam=JSON.parse(JSON.stringify(Modallfiltro))">
                      <i style="font-size: 25px;" class="fa fa-search"> </i>
                      Filtrar
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <v-navigation-drawer > --------->

                <BarraDinamicaLimitePlus :PropsNombre="'Cotizacion'" PropsSearch
                  :PropsSeachNombre="'Búsqueda por nombre'" :TbPaginator="TbPaginator" :TbTotalItem="TbTotalItem"
                  :PropsList="ListContizacion" @CargarPaginacion="CargarPaginacion" @EmitDAta="datostabla" :headers="[
                  { text: 'Código', value: 'secuencia' },
                 /* { text: 'Nombre', value: 'nombre' },
                  { text: 'Balance', value: 'balancecliente.balance' }*/
                  ]" :ContListSlot="[
                  {Text:'Código',NomValue:'secuencia', Ctsl:1, Type:0, State:true},
                  {Text:'Nombre', NomValue:'nombrecliente',  Ctsl:1, Type:0, State:true},
                  {Text:'teléfono', NomValue:'telefono',  Ctsl:1, Type:0, State:true},
                  {Text:'Correo', NomValue:'correo',  Ctsl:1, Type:0, State:true},
                  {Text:'Valor $',NomValue:'valor' , Ctsl:1, Type:2, State:true},
                  // {Text:'Estado',NomValue:'activado', Ctsl:1, Type:0.1, State:true},
                  ]" />
              </template>
            </v-tooltip>




          </div>
        </td>
        <!-- fn BarraPrimaria-Cotizacion Basica---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height-96">
          <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">

<!-- Formulario-Cotizacion Basica  -->
            <div class="px-2">

              <v-card color="grey lighten-3">
                <div class="px-2" style="border: 1px solid #000000;">

                  <v-form ref="formFCotizar" @submit.prevent="" v-model="valid" lazy-validation>
                    <!-- row 1 -->
                    <v-row>
                      <v-col cols="12" md="6" sm="6">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-combobox id="formTecniInput" v-on="on" autocomplete="off" dense outlined label="cliente:"
                              :items="RCliente" item-text="codnom" :rules="[$rules.required]" :suffix="clientTel"
                              style="font-size: 13px;" v-model="cliente" @blur="SelctCbCliente" @change="ClienteSelect"
                              @focus="cargarCliente" @keyup="CbFilcliente" ref="RefCmCliente" no-filter>

                              <template slot="item" slot-scope="item">
                  <span style="display:none;">{{ item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} ` }}</span>
                  <span class="fontSize13"><b>{{ item.item.codigo}}</b> - {{item.item.nombre.trim()}}</span>
                  </template>

                  <template v-slot:selection="{ attrs, item, parent, selected }">
                    <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.nombre}}</span>
                    <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                  </template>
                              <template v-slot:prepend>
                                <i style="font-size: 20px;" class="fa fa-user-circle"></i>
                              </template>

                            </v-combobox>
                          </template>
                          <i style="font-size: 20px;" dark dense class="fa fa-info-circle">
                            <span> Se muestra el cliente correspondiente a la factura de venta.</span>
                          </i>
                        </v-tooltip>
                      </v-col>

                      <v-col cols="12" md="3" sm="3">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" dense outlined type="date" label="Fecha"
                              v-model="CotizacionBasica.fecha" :rules="[$rules.required]" placeholder=" "
                              style="font-size: 12px;">
                              <template v-slot:prepend>
                                <i style="font-size: 16px;" class="fa fa-calendar"></i>
                              </template>
                            </v-text-field>
                          </template>
                          <i style="font-size: 20px;" dark dense class="fa fa-info-circle">
                            <span> Se muestra la fecha de la factura de venta.</span>
                          </i>
                        </v-tooltip>

                      </v-col>

                      <v-col cols="12" md="3" sm="3">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">

                            <v-text-field v-on="on" id="ImputColorDisable" label="No.Cotización:" dense
                              autocomplete="off" outlined v-model.number="CotizacionBasica.secuencia"
                              style="font-size: 13px;" disabled>
                              <template v-slot:prepend>
                                <i style="font-size: 18px;" class="fa fa-hashtag"></i>
                              </template>
                            </v-text-field>
                          </template>
                          <i style="font-size: 20px;" dark dense class="fa fa-info-circle">
                            <span> Se muestra el número de la factura de venta.</span>
                          </i>
                        </v-tooltip>
                      </v-col>

                    </v-row>
                    <!-- fn row 1 -->

                    <!-- row 2 -->
                    <v-row style="margin-top:-25px">

                      <v-col cols="12" md="3" sm="3">
                        <v-text-field label="Teléfono:" dense outlined autocomplete="off" maxlength="13"
                          v-mask="'(###)###-####'" v-model="CotizacionBasica.telefono">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-phone"></i>
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" md="3" sm="3">
                        <v-text-field label="Valido Hasta:" autocomplete="off" dense outlined
                          v-model="CotizacionBasica.valido">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-clock-o"></i>
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" md="3" sm="3">
                        <v-text-field label="Condición de Pago:" autocomplete="off" dense outlined
                          v-model="CotizacionBasica.conceptoPago">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-money"></i>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" sm="3">
                        <v-text-field label="Correo:" dense outlined autocomplete="off"
                          v-model="CotizacionBasica.correo" :rules="[$rules.email]">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-envelope-o"></i>
                          </template>
                        </v-text-field>

                      </v-col>

                    </v-row>
                    <!-- fn row 2 -->

                    <!-- row 3 -->
                    <v-row style="margin-top:-25px">
                      <v-col cols="12" md="6" sm="6">
                        <v-textarea autocomplete="off" label="*Dirección:" rows="1" dense outlined
                          v-model="CotizacionBasica.direccion" :rules="[$rules.required]">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-map-marker"></i>
                          </template>
                        </v-textarea>
                      </v-col>
                      <v-col cols="12" md="6" sm="6">
                        <v-textarea autocomplete="off" label="Detalle:" rows="1" dense outlined
                          v-model="CotizacionBasica.concepto">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-commenting"></i>
                          </template>
                        </v-textarea>

                      </v-col>

                    </v-row>
                    <!-- fn row 3 -->

                    <!-- row 4 -->
                    <v-row style="margin-top:-25px">

                      <v-col cols="12" md="3" sm="3">

                        <v-tooltip top>
                          <template v-slot:activator="{ on }">

                            <v-combobox v-on="on" v-model="CotizacionBasica.caja" label="Caja"
                              :rules="[$rules.required]" outlined dense autocomplete="off" :items="RCaja"
                              item-text="descripcion" @blur="SelctCbCaja" @focus="cargarCaja" style="font-size: 13px;">
                              <template v-slot:prepend>
                                <i style="font-size: 20px;" class="fa fa-cube"></i>
                              </template>
                            </v-combobox>




                            <!-- <v-combobox
v-on="on"
            autocomplete="off"
            dense
            outlined
           
            label="Succursal:"
            :items="RSucursal"
            :rules="[$rules.required]"
            item-text="descripcion"
            v-model="CotizacionBasica.sucursal"
            @blur="SelctCbSucursal"
            @focus="cargarSucursal"
            style="font-size:13px;"
            
          >
            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-sitemap"></i>
            </template>
          </v-combobox> -->


                          </template>
                          <i style="font-size: 20px;" dark dense class="fa fa-info-circle">
                            <span> Se muestra la sucursal en la cual se hizo la factura de venta.</span>
                          </i>
                        </v-tooltip>

                        <!-- <v-switch
              class="mt-0"
              v-model="CotizacionBasica.activada"
              label="Activo"
              color="success"
              hide-detail

              >

        <template v-slot:label>
         <strong v-if="CotizacionBasica.activada==true"  style="color:#000000; font-size: 13px; ">Activo: Si</strong>
         <strong v-if="CotizacionBasica.activada==false" style="color:#000000; font-size: 13px; ">Activo: No</strong>
        </template>        
</v-switch> -->
                      </v-col>

                      <v-col cols="12" md="3" sm="3">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">

                            <VueAutonumeric v-on="on" label="ITBIS:" dense outlined autocomplete="off" disabled
                              v-model.number="CotizacionBasica.valorimpuesto" style="font-size: 13px;"
                              id="formTecniInput">
                              <template v-slot:prepend>
                                <i style="font-size: 20px;" class="fa fa-ravelry"></i>
                              </template>
                            </VueAutonumeric>

                          </template>
                          <i style="font-size: 20px;" dark dense class="fa fa-info-circle">
                            <span> Se muestra el valor de itbis correspondiente a la factura.</span>
                          </i>
                        </v-tooltip>
                      </v-col>

                      <v-col cols="12" md="3" sm="3">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">

                            <VueAutonumeric v-on="on" label="Descuento:" dense outlined autocomplete="off"
                              v-model.number="CotizacionBasica.valordescuento" style="font-size: 13px;" disabled
                              id="formTecniInput">
                              <template v-slot:prepend>
                                <i style="font-size: 20px;" class="fa fa-usd"></i>
                              </template>
                            </VueAutonumeric>

                          </template>
                          <i style="font-size: 20px;" dark dense class="fa fa-info-circle">
                            <span> Se muestra el valor descontado a la factura.</span>
                          </i>
                        </v-tooltip>
                      </v-col>

                      <v-col cols="12" md="3" sm="3">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <VueAutonumeric v-on="on" label="Valor:" dense outlined autocomplete="off"
                              v-model.number="CotizacionBasica.valor" :rules="[$rules.Numericc]" disabled
                              id="formTecniInput" style="font-size: 13px;">
                              <template v-slot:prepend>
                                <i style="font-size: 20px;" class="fa fa-money"></i>
                              </template>
                            </VueAutonumeric>
                          </template>
                          <i style="font-size: 20px;" dark dense class="fa fa-info-circle">
                            <span> Se muestra el valor final de la factura.</span>
                          </i>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <!-- fn row 4 -->

<!-- row 5 -->
<v-row style="margin-top:-25px">
      <v-col cols="12" md="6" sm="6" >
        <v-checkbox   class="mt-0 ma-3"
                            v-model="CotizacionBasica.provedorEstado" label="" color="teal " hide-details>
                            <template v-slot:label>
                              <strong v-if="CotizacionBasica.provedorEstado == true"
                                style="color:#000000; font-size:13px;">Proveedor del estado: Si</strong>
                              <strong v-if="CotizacionBasica.provedorEstado == false"
                                style="color:#000000; font-size:13px;">Proveedor del estado: No</strong>
                            </template>
                          </v-checkbox>
                      </v-col>
</v-row>
<!-- fn row 5 -->

                  </v-form>

                  <v-col cols="12" md="12" sm="12" style="margin-top:-25px;">

                    <!-- @click:row="datostabla" -->

                    <v-card>

                      <v-toolbar flat color="indigo" dense>

                        <v-card-actions v-if="windowSize.width >600">
                          <!-- :disabled="CotizacionBasica.facturasventaPK.secuencia<=0"  -->
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">

                              <v-btn dark rounded v-on="on"
                                @click.prevent="dialogAddProducto =!dialogAddProducto" color="green">
                                <i style="font-size: 20px;" class="fa fa-plus-square"></i><!-- fab x-small dark  -->
                                Agregar
                              </v-btn>
                            </template>
                            <span>Agregar Productos</span>
                          </v-tooltip>

                        </v-card-actions>

                        <v-spacer></v-spacer>
                        <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
                      </v-toolbar>


                      <div style="border: 1px solid #000000;">
                        <v-data-table id="TbBord" :headers="[{ text: 'Cod.Producto', sortable: false, value: 'productos.codigo', width:90, class: ['no-gutters black--text'] },
                        { text: 'Producto', sortable: false,value: 'descripcion', width:329, class: ['no-gutters black--text'] },
                         { text: 'Cant', sortable: false,  align: 'center',value: 'cantidad', width:100, class: ['no-gutters black--text'] },
                        { text: 'Precio (Sin Impuesto)',align: 'center', sortable: false, value: 'precio', width:160, class: ['no-gutters black--text'] },
                        { text: 'Impuesto', sortable: false,align: 'center', value: 'valorimpuesto', width:130, class: ['no-gutters black--text'] },
                        { text: 'Descuento', sortable: false,align: 'center', value: 'valorpordesc', width:150, class: ['no-gutters black--text'] },
                        { text: 'Des', sortable: false, align: 'center', value: 'descuentoPorciento', width:120, class: ['no-gutters black--text'] },
                        { text: 'Valor', sortable: false, align: 'center',value: 'valorr', width:150,  class: ['no-gutters black--text'] },    
                        { text: 'Acción', sortable: false, align: 'center', value: 'action', width:'auto', width:105, class: ['no-gutters black--text'] }, 
                        ]" dense :items="CotizacionBasica.cotizacionDetalleList" :search="search" :items-per-page="15">

                          <!-- style="margin-right:-80px;" -->
                          <template v-slot:item.action="{ item }">

                            <!-- { text: 'Acción', sortable: false, value: 'action', width:'auto' }, -->
                            <v-btn fab @click.prevent="deleProducto(item)"
                              x-small color="red darken-3"><i style="font-size: 20px;" class="fa fa-trash-o"></i>
                            </v-btn>
                            <!-- <v-btn fab @click.prevent="deleFact(item)" x-small color="red darken-3"><i style="font-size: 20px;" class="fa fa-trash-o"></i></v-btn> -->
                          </template>

                          <template v-slot:item.productos.codigo="props">
                            <v-text-field autocomplete="off" label="" dense outlined
                              :value="props.item.productos.codigo" style="font-size:13px;" disabled id="formTecniInput"
                              hide-details>
                            </v-text-field>
                          </template>



                          <template v-slot:item.descripcion="props">
                            <!-- <span style="font-size:13px;" >{{ props.item.descripcion }}</span> -->

                            <v-text-field label="" autocomplete="off" dense outlined v-model="props.item.descripcion"
                              style="font-size:13px;" hide-details>
                            </v-text-field>
                          </template>

                          <template v-slot:item.valorr="props">
                            <VueAutonumeric autocomplete="off" label="" dense outlined v-model="props.item.valor"
                              style="font-size:13px;" disabled id="formTecniInput" hide-details>
                            </VueAutonumeric>
                          </template>


                          <template v-slot:item.cantidad="props">

                            <v-text-field label="" autocomplete="off" dense outlined
                              v-model.number="props.item.cantidad" @keyup="KeyUpCantidad" style="font-size:13px;"
                              v-on:keyup="CalcularCotiz" @blur="BlurVerifCantPenCant(props.item)" hide-details>
                            </v-text-field>
                            <!-- v-on:keyup="CalcularDenominacion" -->
                          </template>

                          <template v-slot:item.precio="props">
                            <VueAutonumeric autocomplete="off" label="" dense outlined v-model="props.item.precio"
                              style="font-size:13px;" @input="CalcularCotiz" hide-details @blur="recalcularImpuestoProducto(props.item)">
                            </VueAutonumeric>
                          </template>



                          <template v-slot:item.valorimpuesto="props">
                            <span style="display:none;"
                              v-if="props.item.valorimpuesto==null">{{props.item.valorimpuesto=0}}</span>

                            <VueAutonumeric autocomplete="off" label="" dense outlined
                              v-model="props.item.valorimpuesto" style="font-size:13px;" @input="CalcularCotiz"
                              hide-details>
                            </VueAutonumeric>
                          </template>


                          <template v-slot:item.valorpordesc="props">

                            <VueAutonumeric v-if="props.item.descuentoPorciento==false" autocomplete="off" label=""
                              dense outlined v-model="props.item.valordescuento" style="font-size:13px;"
                              @input="CalcularCotiz" hide-details>
                            </VueAutonumeric>

                            <VueAutonumeric v-if="props.item.descuentoPorciento==true" autocomplete="off" label="" dense
                              outlined v-model="props.item.descuento" style="font-size:13px;" @input="CalcularCotiz"
                              hide-details>
                            </VueAutonumeric>

                          </template>


                          <template v-slot:item.descuentoPorciento="props">
                            <v-switch class="" v-model="props.item.descuentoPorciento" label="Activo" color="success"
                              hide-detail dense @change="ChangeDescPorc(props.item)">

                              <template v-slot:label>
                                <strong v-if="props.item.descuentoPorciento==true"
                                  style="color:#000000; font-size: 20px; ">%</strong>
                                <strong v-if="props.item.descuentoPorciento==false"
                                  style="color:#000000; font-size: 20px; ">$</strong>
                              </template>

                            </v-switch>
                          </template>



                          <template v-slot:item.valor="props">
                            <span>{{currencyFormatter(props.item.valor)}} </span>
                          </template>

                          <template v-slot:body.append v-if="windowSize.width >600">
      <tr>

        <td class="border-top-bottom"><strong></strong></td>
        <td class="border-top-bottom"><strong class="d-flex justify-end"
            style="font-size:11px; color: #00838F;">Total:</strong></td>
        <td class="border-total"><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;">
            {{Totales.Cant}} </strong></td>
        <td class="border-total"><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;">
            {{currencyFormatter(Totales.Precio)}} </strong></td>
        <td class="border-total"><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;">
            {{currencyFormatter(Totales.Impuresto)}} </strong></td>
        <td class="border-total"><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;">
            {{currencyFormatter(Totales.Descuento)}} </strong></td>
        <td class="border-top-bottom"><strong></strong></td>
        <td class="border-total"><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;">
            {{currencyFormatter(Totales.Valor)}} </strong></td>
        <td class="border-top-bottom"><strong></strong></td>
      </tr>
</template>

<template v-slot:footer v-if="windowSize.width<=600">
  <v-list-item style="font-size: 70%;" class="white--text">
    <v-list-item-content>
      <span>Total de horas:{{currencyFormatter(Totales.Precio)}} </span>
    </v-list-item-content>
  </v-list-item>
</template>

</v-data-table>

</div>



</v-card>

</v-col>




</div>
</v-card>



</div>
<!-- fn Formulario-Cotizacion Basica  -->
</v-app>
</td>
<!-- fn contenido central ------------------------------------------------------------------------------------->
<!-- BarraSecundaria ------------------------------------------------------------------------------------------>
<td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir">

  <div class="overflow-y-auto "
    v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">

    <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
  </div>

</td>
<!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



</tr>
</table>
<!-- Modales -------------------------------------------------------------------------------------------------->
<!-- ------------------------------------------------------ tb-data todo general-->
<v-dialog label="myAlert" v-model="acti_tb_data" persistent transition="dialog-bottom-transition" fullscreen
  hide-overlay>
  <v-card>
    <v-toolbar flat color="#BDBDBD">
      <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
      <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
      <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>

      <v-spacer></v-spacer>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn v-if="false" v-on="on" dark small color="deep-purple accent-2"
            @click.prevent="dialogimprimirListFilt=true, datosImprecion.secuencia=0">
            <i style="font-size: 25px;" class="fa fa-print"> </i>
            Listado
          </v-btn>

        </template>
        <span>Imprimir Listado</span>
      </v-tooltip>
      <v-btn color="grey darken-4" fab small @click="actualiza_tb_ver">
        <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
      </v-btn>
    </v-toolbar>

    <v-card-text>
      <v-card>
        <v-card-title>
          <v-text-field v-model="Modallfiltro.cliente" @keyup="CargarListTb" label="Buscar" single-line hide-details>
            <template v-slot:prepend-inner>
              <i style="font-size: 35px;" class="fa fa-search"></i>
            </template>
          </v-text-field>
        </v-card-title>
        <v-data-table class="TbSize13" :headers="[
          { text: 'Código', sortable: false, value: 'secuencia', class:['black--text'] },
          { text: 'Nombre', sortable: false, value: 'nombrecliente',class: ['no-gutters black--text'] },
          { text: 'teléfono:', sortable: false , value: 'telefono', class: ['no-gutters black--text'] },
          { text: 'Correo', sortable: false , value: 'Correo',  class: ['no-gutters black--text'] },
          { text: 'Valor:', sortable: false, value: 'valor',  class: ['no-gutters black--text'] }
        ]" dense @pagination="cargarPaginacionAll" :items-per-page="TbPaginator.itemsPerPage" :page="TbPaginator.page"
          :pageCount="TbPaginator.pageCount" :items="ListContizacion" :search="Modallfiltro.cliente"
          @click:row="datostabla" :server-items-length="TbTotalItem">
          <template v-slot:item.activado="props">
            <span v-if="props.item.activado==true" style="font-size:13px;">Activo</span>
            <span v-if="props.item.activado==false" style="font-size:13px;">In-Activo</span>
          </template>


          <template v-slot:item.fechanacimiento="props">
            <span style="font-size:13px;">{{FormatoFecha(props.item.fechanacimiento)}}</span>
          </template>
        </v-data-table>
      </v-card>
    </v-card-text>
  </v-card>
</v-dialog>
<!-- ------------------------------------------------------ fn tb-data todo general -->



<!-- ------------------------------------------------------ notif-->
<v-dialog label="myAlert" v-model="notif.estado" persistent max-width="350" transition="fab-transition">
  <template justify="center" v-slot:activator="{ on }"></template>

  <v-card>
    <v-card-title>
      <h4>
        <i style="font-size: 28px;" class="fa fa-warning"></i>
        CONFIRMACION
        <i style="font-size: 28px;" class="fa fa-warning"></i>
      </h4>
    </v-card-title>
    <hr />

    <v-card-text>
      <h5>{{notif.nombre }}</h5>
    </v-card-text>

    <hr />
    <v-card-actions>
      <v-btn v-if="notif.Exec=='eliminarCotizacion'" @click.prevent="eliminar(), (notif.estado = !notif.estado)" small>
        <i style="font-size: 20px;" class="fa fa-check"></i> Si
      </v-btn>

      <v-btn v-if="notif.Exec=='AnularCotizacion'" @click.prevent="Anular(), (notif.estado = !notif.estado)" small>
        <i style="font-size: 20px;" class="fa fa-check"></i> Si
      </v-btn>



      <v-btn @click.prevent="notif.estado = !notif.estado" small>
        <i style="font-size: 20px;" class="fa fa-ban"></i> No
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<!-- ------------------------------------------------------  fn notif -->



<!------------otras funciones---------------->
<v-snackbar v-model="aalert.estado" :color="aalert.color" style="margin-top: 20%;" :vertical="true" :timeout="120000"
  top="top">
  {{ aalert.nombre }}
  <v-btn dark text @click="aalert.estado = false">Close</v-btn>
</v-snackbar>




<v-dialog v-model="dialogReporte" persistent fullscreen hide-overlay transition="dialog-bottom-transition">

  <v-card>
    <v-toolbar dark color="grey darken-2">

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">

          <v-toolbar-title v-on="on">
            Imprecion de reporte
          </v-toolbar-title>

        </template>
        <i style="font-size: 20px;" dark dense class="fa fa-info-circle">
          <span> Imprecion: </span> Vista e Imprecion del reporte</i>

      </v-tooltip>

      <!-- <v-toolbar-title>Ordenes De Compras sugeridas</v-toolbar-title> -->

      <v-spacer></v-spacer>


      <v-btn color="grey darken-4" fab small @click="NewReporte">
        <i style="font-size: 20px; color:white;" class="fa fa-close"></i>
      </v-btn>
    </v-toolbar>

    <v-list three-line subheader>
      <pdf-app style="height: 100vh;" :pdf="pdf" :config="config"></pdf-app>

    </v-list>
  </v-card>
</v-dialog>


<!-- ------------------------------------------------------ Modal-Filtro tb-datos -->
<v-dialog transition="fab-transition" label="Modal agregar factura" v-model="dialogFiltros" persistent max-width="60%"
  max-height="50%">
  <v-card>

    <v-toolbar flat color="indigo">

      <i style="font-size: 20px;" class=""> </i>
      <v-toolbar-title style="color:white;" class="font-weight-light"> <b>FILTROS</b></v-toolbar-title>
      <i style="font-size: 20px;" class=""> </i>

      <v-spacer></v-spacer>
      <v-btn color="grey darken-4" fab small
        @click="dialogFiltros=false, Modallfiltro=JSON.parse(JSON.stringify(ObjTemTbDinam))">
        <i style="font-size: 20px; color:white;" class="fa fa-close"></i>
      </v-btn>
    </v-toolbar>

    <v-card-text>
      <br>




      <v-row>


        <v-col cols="12" md="12">
          <!-------------------------------------------------- Nombre  -->

          <v-text-field id="formdisabledInput" label="Cliente:" autocomplete="off" dense outlined
            v-model="Modallfiltro.cliente">
            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-user-circle"></i>
            </template>
          </v-text-field>


          <!-- ----------------------------- Tipo de Cliente -->

          <!-- <v-switch
              v-model="Modallfiltro.activos"
              label="Activos"
              color="success"
              hide-detail

              ></v-switch> -->
        </v-col>




      </v-row>


    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn-toggle dense rounded class="">


        <v-btn dark color="#90A4AE" @click.prevent="Limpiarfiltro">
          <i style="font-size: 28px;" class="fa fa-file-o"> </i>
          Limpiar filtro
        </v-btn>

        <v-btn dark color="blue lighten-1" @click.prevent="BuscarFiltros">
          <i style="font-size: 28px;" class="fa fa-search"> </i>
          Buscar
        </v-btn>

      </v-btn-toggle>

    </v-card-actions>

  </v-card>
</v-dialog>

<!-- ------------------------------------------------------ fn Modal-Filtro tb-datos-->

<!-- ------------------------------------------------------ Modal-selecion de Produecto -->
<v-dialog transition="fab-transition" label="Modal agregar producto" v-model="dialogAddProducto" persistent
  max-width="90%" max-height="80%">
  <!-- :PropsUnidadminima="true"|| :PropsUnidadminima="this.$store.getters.GetConfiguracionGeneral.configCxp.unidadminima"  -->
  <AgregarProducto :statusFoms="dialogAddProducto" @EmitAgregarProducto="RecAgregarProducto" :unidadminima="this.$store.getters.GetConfiguracionGeneral.configCxp.unidadminima" />
</v-dialog>
<!-- ------------------------------------------------------ fn Modal-selecion de Produecto-->


<v-dialog v-model="Reparaloading" persistent width="300">
  <v-card color="grey darken-2" dark>
    <v-card-text>
      <br>
      <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
    </v-card-text>
  </v-card>
</v-dialog>




<!-- fn Modales ----------------------------------------------------------------------------------------------->


</div>
</template>

<script>

//import AgregarProducto from "@/UtilidadComponents/AgregarProducto.vue";
import AgregarProducto from "@/CuentaXPagar/UtilidadComponents/AgregarProducto.vue";
import { EventBus } from "../../event-bus";
import BarraDinamicaLimitePlus from "../../components/BarraDinamicaLimitePlus";
import VueAutonumeric from "../../components/AutoNumericNuevo";
import CuentasContables from "@/UtilidadComponents/CuentasContables";
import ContenidoBase from "../../components/ContenidoBase";
import { currencyFormatter, FormatoFecha, HoraFormatter } from "@/js/Funciones.js";
export default {

  components: {
    BarraDinamicaLimitePlus,
    VueAutonumeric,
    CuentasContables,
    PdfApp: window["pdf-viewer"],
    AgregarProducto,
    ContenidoBase
  },


  created() {

  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("emitUtilitarioFactVent", this.datostabla);

    // this.cargarTodo();
    var mond = this.$store.getters.GetConfiguracionGeneral.config.monedabase
    this.CotizacionBasica.tasa = mond.tasa
    this.CotizacionBasica.moneda = mond.codigo

  },

  data: () => ({

    contabilidad: null,
    selected: [],
    config: { findbar: false },
    pdf: "",

    ListaTiposClientes: [],
    listFactVent: [],
    facturasVentaList: [],
    windowSize: { width: "auto", height: "auto" },

    Reparaloading: false,

    disableAll: false,
    dialogReporte: false,
    dialogAddProducto: false,
    disabledRestFacVenta: true,
    disableRecalBalClient: false,


    RComprobantes: [],
    Ralmacen: [],
    Rpropietario: [],
    RCaja: [],
    RCliente: [],
    RDocumento: [],
    Rvendedor: [],

    Ralmacen: [],
    RfilVendedor: "nombre",
    clientTel: '',


    TotalRegistros: 1,
    resertPagi: true,
    paginator: {
      itemsPerPage: 15,
      pageStart: 1,
      page: 1,
      pageStop: 15,
      pageCount: 10,
      itemsLength: 5
    },


    dialogFiltros: false,

    Modallfiltro: {
      cliente: null,
      activos: true

    },

    ObjTemTbDinam: null,
    ListContizacion: [],
    TbTotalItem: 0,
    TbPaginator: {
      page: 1,
      itemsPerPage: 5,
      pageStart: 1,
      pageStop: 15,
      pageCount: 10,
      itemsLength: 5
    },



    ObjAnteFac: null,
    GenerarContloading: false,

    EstadoBtn: {
      BarraTablaDinamicaAprir: true,
      nuevo: true,
      guardar: true,
      eliminar: false,
      anular: false,
      imprimir: true,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
      etiquetaXfactura: false
    },

    cliente: null,

    ejecucion: true,
    CotizacionBasica: {
      secuencia: 0,
      fecha: null,
      nombrecliente: "",
      valor: 0,
      facturada: false,
      tipocomprobante: null,
      valordescuento: 0,
      tasaimpuesto: null,
      valorimpuesto: 0,
      descuento: null,
      cajero: null,
      telefono: "",
      direccion: "",
      correo: "",
      conceptoPago: "",
      valido: "",
      concepto: "",
      tasa: 1,
      moneda: 1,
      cotizacionDetalleList: [],
      caja: null,
      cliente: null,
      sucursal: null,
      vendedor: null,
      provedorEstado:false
    },
    CotizacionBasica1: {
      //fecha:fechaNueva(),
      fecha: "",
      documentoFactura: null,
      facturasventaPK: {
        secuencia: 0
      },
      ncf: '',
      cliente: null,
      tipocomprobante: null,
      sucursal: null,
      telefono: '',
      cobertura: null,
      autorizacion: null,
      medico: null,
      coberturaPendiente: null,
      diascredito: 0,
      comentario: "",
      valordescuento: 0,
      valorimpuesto: 0,
      totalIsr: 0,
      totalOtroImpuesto: 0,
      valor: 0,
      efectivo: 0,
      cheques: 0,
      tarjeta: 0,
      valorNc: 0,
      cupones: 0,
      valorasignacion: 0,
      puntos: 0,
      valorbonogas: 0,
      cxc: 0,
      pendiente: 0,
      valordonacion: 0,
      valorPruebaMetro: 0,
      valorTraspaso: 0,
      valorPruebaMetro: 0,
      activada: true
    },


    Totales: {
      Cant: 0, Precio: 0, Impuresto: 0, Descuento: 0, Valor: 0
    },


    TotalCuenta: {
      credito: 0,
      debito: 0
    },


    RTipo: [
      { codigo: 1, descripcion: "Valor" },
      { codigo: 2, descripcion: "Porcentaje" },
    ],

    RPagosAnticipado: [
      { p: 'Arros', e: '5', c: '200' },
      { p: 'aguacate', e: '15', c: '100' },
      { p: 'guineo', e: '25', c: '50' },
      { p: 'papa', e: '50', c: '80' },
      { p: 'pera', e: '60', c: '90' }

    ],





    text: "",
    valid: true,
    BarraPrimariaAbrir: false,
    BarraSecundariaAprir: false,

    headers: [{ text: "Tipo Clientes", value: "descripcion" }],

    slotlist: [
      { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:"
      },
      { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
    ],



    list: [],
    search: "",
    acti_tb_data: false,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?"
    },


    notif: {
      estado: false,
      nombre: "",
      Exec: ""
    },


    aalert: {
      estado: false,
      color: null
    },

  }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {

    currencyFormatter,
    FormatoFecha,
    HoraFormatter,
   // Abriendo un modal con una tabla de datos.
    abrirTabla() {
      this.BarraPrimariaAbrir = !this.BarraPrimariaAbrir;
      if (this.BarraPrimariaAbrir) {
        this.CargarListTb();
      }
    },
    async cargarTodo() {
      // await this.$axios
      //   .post(
      //     this.$hostname +
      //       this.$hName +
      //       "/services/tipocliente/findalltipoclientes",
      //     {
      //       usuario:JSON.parse(JSON.stringify(this.$user)) 
      //     }
      //   )
      //   .then(res => (this.ListaTiposClientes = res.data))
      //   .catch(error => console.log(error));
    },



    // Tomando los datos de la base de datos y poniéndolos en una tabla.
    datostabla(e) {
      this.cliente =null

      var eftc = JSON.parse(JSON.stringify(e))
      eftc.fecha = new Date(e.fecha).toISOString().substr(0, 10);
      if (e.cliente != null) {
        this.cliente = e.cliente
      }
      if (e.nombrecliente != null && e.cliente == null) {
        this.cliente = e.nombrecliente
      }
      eftc.cotizacionDetalleList.forEach(element => {
        element.descuentoPorciento = false

        if (element.descuento > 0) {
          element.descuentoPorciento = true
        }


      });


      this.CotizacionBasica = eftc

      setTimeout(this.CalcularCotiz, 200);



    },
   // Guardando los datos en la base de datos.
    save() {


      if (this.CotizacionBasica.cotizacionDetalleList.length == 0) {
        this.alerta("Agrege al menos 1 producto a la lista", "error")
        return 0;
      }


      if (this.$refs.formFCotizar.validate()) {

        EventBus.$emit("loading", true);
        if (this.ejecucion == true) {

          this.CotizacionBasica.nombrecliente = this.$refs.RefCmCliente.internalSearch
          if (this.cliente.hasOwnProperty('codigo')) {
            this.CotizacionBasica.cliente = this.cliente
            this.CotizacionBasica.nombrecliente = this.cliente.nombre.trim()
          }else{
            this.CotizacionBasica.nombrecliente = this.cliente
          }

          this.ejecucion = false
          this.CotizacionBasica.pv=false
          this.$axios
            .post(
              this.$hostname +
              this.$hName +
              "/cotizacion/save", this.CotizacionBasica,
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then(res => { 
              this.alerta("Dato guardado correctamente!", "bien") 
            })
            .catch(error => { 
              EventBus.$emit("loading", false);
              this.alerta("Dato no guardado", "error") });


        }


      } else {
        this.alerta("Los campos en rojo son requeridos", "error");
      }

    },






    NotifMessage() {

      if (this.CotizacionBasica.codigo != 0 && this.CotizacionBasica.codigo != null) {

        var notif = {
          estado: true,
          nombre: "¿Seguro que desea eliminar este Registro?",
          Exec: "eliminarCotizacion"
        }
        //,AnularCotizacion
        this.Exec_notif(notif)


      } else { this.alerta("Seleccione un tipo de impuesto para eliminar", "error") }


    },

    Exec_notif(e) {

      //console.log(e)
      this.notif = JSON.parse(JSON.stringify(e))

      //this.Elim_notif.estado = !this.Elim_notif.estado;
    },





    remove() {

      if (this.CotizacionBasica.codigo != 0 && this.CotizacionBasica.codigo != null) {

        this.Elim_notif.estado = !this.Elim_notif.estado;
      } else { this.alerta("Seleccione un tipo de cliente para eliminar", "error") }


    },
    eliminar() {

      var jsn = {
        datos: JSON.parse(JSON.stringify(this.CotizacionBasica)),
        usuario: JSON.parse(JSON.stringify(this.$user))
      }

      if (this.CotizacionBasica.codigo != 0) {
        this.$axios
          .post(
            this.$hostname +
            this.$hName +
            "/cotizacion/remove",
            JSON.parse(JSON.stringify(jsn))
          )
          .then(res => { this.alerta(res.data.mensage, res.data.estado) })
          .catch(error =>
            this.alerta(
              // "hubo un error , por favor verifique el campo descripcion!"
              "Dato no eliminado",
              "error"
            )
          );
      }


    },
    anular() {

    },
    // Enviando una solicitud al servidor y el servidor devuelve un archivo PDF.
    imprimirList() {
      EventBus.$emit("loading", true);
      var headers = this.$store.getters.GetheadersAxios

this.$axios.get(this.$hostname + this.$hName + "/cotizacion/imprimir/"+this.CotizacionBasica.secuencia, { headers: headers }).then(res => {
  EventBus.$emit("loading", false)
  console.log('RespuestaImprimir'), console.log(res.data)
  /*let pdfWindow = window.open("Reporte de imprecion")
  pdfWindow.document.write("<embed width='100%' height='100%' type='application/pdf'   src='data:application/pdf;base64," +
    encodeURI(res.data) + "'></embed>")*/

    var PDF=`data:application/pdf;base64,${encodeURI(res.data)}`;
      EventBus.$emit("openPDF",PDF ,'imprimir cotizacion');

});



    },
    // Creando un nuevo objeto y asignándolo a la variable this.CotizacionBasica.
    newwnuevo() {

      this.selected = []

      this.cliente = "";
      this.CotizacionBasica = {
        secuencia: 0,
        fecha: null,
        nombrecliente: "",
        valor: 0,
        facturada: false,
        tipocomprobante: null,
        valordescuento: 0,
        tasaimpuesto: null,
        valorimpuesto: 0,
        descuento: null,
        cajero: null,
        telefono: "",
        direccion: "",
        correo: "",
        conceptoPago: "",
        valido: "",
        concepto: "",
        tasa: 1,
        moneda: 1,
        cotizacionDetalleList: [],
        caja: null,
        cliente: null,
        sucursal: null,
        vendedor: null,
        provedorEstado:false
      },

        this.Totales = {
          Cant: 0, Precio: 0, Impuresto: 0, Descuento: 0, Valor: 0
        }
      this.ejecucion = true
      EventBus.$emit("loading", false);
      this.CargarListTb();
      //   EventBus.$emit("actualizaBarraBusqueda2");
    },

    NewReporte() {


      this.dialogReporte = false


    },


    imprimiir() {

      window.print()

    },


   // Un método que se llama cuando el usuario abandona el campo de entrada.
    BlurVerifCantPenCant(e) {


      e.cantidadPendiente = e.cantidad

      // if(e.hasOwnProperty('facturasventaDetallePK')){

      // this.alerta("Aparentemente  esta factura tiene una devolución (Revise)","error")


      // }
      // else{

      // }

    },


   // Una función que se llama cuando se hace clic en una casilla de verificación.
    ChangeDescPorc(e) {

      //descuentoPorciento,valordescuento,descuento   
      if (e.descuentoPorciento == true) {
        e.descuento = e.valordescuento
        e.valordescuento = 0
      } else {
        e.valordescuento = e.descuento
        e.descuento = 0
      }




      setTimeout(this.CalcularCotiz, 200);

    },


    // Cálculo del valor total de los elementos de la lista.
    CalcularCotiz() {



      this.Totales = {
        Cant: 0, Precio: 0, Impuresto: 0, Descuento: 0, Valor: 0
      }



      this.CotizacionBasica.cotizacionDetalleList.forEach(element => {

        var des = 0

        if (element.descuentoPorciento == true) {

          des = (((element.precio * element.cantidad) * element.descuento) / 100)

        } else {
          des = (element.valordescuento * element.cantidad)
        }


        element.valor = ((element.precio * element.cantidad) + (element.valorimpuesto* element.cantidad) - (des))
        this.Totales.Cant += element.cantidad
        this.Totales.Precio += element.precio
        this.Totales.Impuresto += (element.valorimpuesto* element.cantidad)
        //this.Totales.Descuento += element.valordescuento
        this.Totales.Descuento += des

        this.Totales.Valor += element.valor


      });



      this.CotizacionBasica.valorimpuesto = this.Totales.Impuresto
      this.CotizacionBasica.valordescuento = this.Totales.Descuento
      // this.CotizacionBasica.valor = this.Totales.Valor -this.Totales.Impuresto
      this.CotizacionBasica.valor = this.Totales.Valor 

    },


    recalcularImpuestoProducto(e){
var tasaImpuest =0.00;
        var valorImpuesto = 0.00;
        var impuestoPrecio = false;
        var PRECIOPROD=e.precio

      var _this = this;
        setTimeout(function () {
          if (e.productos !=null && e.productos.hasOwnProperty('impuesto') && e.productos.impuesto!=null) {
          tasaImpuest = e.productos.impuesto.tasa;
          impuestoPrecio = e.productos.incluirimpuestoenprecio;

          console.log('viendoInf-->',impuestoPrecio)
          console.log('viendoInf-->',e)

          if(impuestoPrecio){
           valorImpuesto =   (1 * ((PRECIOPROD - (0 / 1)) * (tasaImpuest / 100)))
          //  valorImpuesto = e.precio - (e.precio / (1+(tasaImpuest/100)));
           // PRECIOPROD= (e.precio-valorImpuesto)

          }else{
            valorImpuesto =(e.precio * (tasaImpuest/100));  
          }
        }

        e.valorimpuesto= valorImpuesto
       e.impuestoIncluido= impuestoPrecio

          _this.CalcularCotiz()
        }, 500);
    },

    // Eliminar el elemento de la matriz.
    deleProducto(item) {

      const index = this.CotizacionBasica.cotizacionDetalleList.indexOf(item)
      var eliminar = confirm('Desea eliminar este producto?') && this.CotizacionBasica.cotizacionDetalleList.splice(index, 1)
      if (eliminar != false) {
        setTimeout(this.CalcularCotiz, 200);
        //this.CalcularDenominacion()
      }

    },

    KeyUpCantidad(e) {

      //  if(e.key.charCodeAt(0)>=48 & e.key.charCodeAt(0)<=57 ){}

      if (e.target.value.length == 0) {

        e.target.value = 0

      }


      if (e.key) {

        var mynumeral = require('numeral')
        e.target.value = mynumeral(e.target.value).value()

        //console.log(mynumeral(""+this.mensajero.metadeenvios)).value()
        if (e.target.value == null) {

          e.target.value = 0
        }

      }
      else {

        e.key = ""

        //console.log("no se puede poner letras o signos")
      }


      if (e.target.value.length == 0) {

        e.target.value = 0
        e.key = 0
      }



    },



    // Agregar un nuevo objeto a la matriz.
    RecAgregarProducto(e) {
      if (e.estado == 'cerrar') {        
        this.dialogAddProducto = e.false
        
      }
      
      if (e.estado == 'datos') {
        var tasaImpuest =0.00;
        var valorImpuesto = 0.00;
        var impuestoPrecio = false;
        var PRECIOPROD=e.datos.precio
        if (e.datos.productos !=null && e.datos.productos.hasOwnProperty('impuesto') && e.datos.productos.impuesto!=null) {
          tasaImpuest = e.datos.productos.impuesto.tasa;
          impuestoPrecio = e.datos.productos.incluirimpuestoenprecio;

          if(impuestoPrecio){
            valorImpuesto = e.datos.precio - (e.datos.precio / (1+(tasaImpuest/100)));
            PRECIOPROD= (e.datos.precio-valorImpuesto)

          }else{
            valorImpuesto =(e.datos.precio * (tasaImpuest/100));  
          }
        }
        var obj = {
          
          cotizacionDetallePK: {
            producto: e.datos.productos.codigo,
            unidad: e.datos.unidades.codigo,
            id: 0,
          },

          cantidad: 1,
          precio: PRECIOPROD,
          descuento: 0,
          valordescuento: 0,
          descuentoPorciento: true,
          tasaimpuesto: tasaImpuest,
          valorimpuesto: valorImpuesto,
          descripcion: e.datos.productos.descripcion,
          borrado: false,
          impuestoIncluido: impuestoPrecio,
          productos: e.datos.productos,
          unidades: e.datos.unidades,
          valor: 0
        }


        this.CotizacionBasica.cotizacionDetalleList.push(obj)
        setTimeout(this.CalcularCotiz, 200);

      }

    },


    getPdf() {
      const pdff =
        "JVBERi0xLjUKJeLjz9MKMyAwIG9iago8PC9Db2xvclNwYWNlL0RldmljZVJHQi9TdWJ0eXBlL0ltYWdlL0hlaWdodCAyODAvRmlsdGVyL0RDVERlY29kZS9UeXBlL1hPYmplY3QvV2lkdGggMzk0L0JpdHNQZXJDb21wb25lbnQgOC9MZW5ndGggNzk1MT4+c3RyZWFtCv/Y/+AAEEpGSUYAAQIAAAEAAQAA/9sAQwAIBgYHBgUIBwcHCQkICgwUDQwLCwwZEhMPFB0aHx4dGhwcICQuJyAiLCMcHCg3KSwwMTQ0NB8nOT04MjwuMzQy/9sAQwEJCQkMCwwYDQ0YMiEcITIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIy/8AAEQgBGAGKAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/aAAwDAQACEQMRAD8A9/ooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiijI9aAEzRVa4v7S1GZ7mKLH95wKxbrxpo9uCBOZSO0a/41hPE0qfxySJckt2dHQa4G7+Io5FraD6yNn9BWJdeNdXueFnES+kagfr1rinmtCPw3ZDrRWx6yDRXm8fiG9s7GzukkaRju8xZGJDjPf0rt9J1e11i0E9u/s6H7yH0Nb4XG06+i0fYqFRSNKiiiu0sKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKrXrlLG4dThliYg+hwamTsrgVLvXtMsSVnvIlcdVzk/kKw7v4gabDkQRyzH1+6K8wLM5yxJJ9ajeRI+GPNfPTzOvP4LI5XWk9jt7v4h3smRbW8cQ9T8xrDu/E+r3ZPmXkgB/hU7R+QrB+0j+FePU1G94qfelRfpXNKder8UmyG5Pdl95pZCS7sT6k1GXUfeYVRSdrhsQRT3B9I0J/lV6DQ9duseVppiB/ilYL/9enHBzl0BQbGecnYk/QVIpzjFaEfgXVZhm5vYovaNSx/PiqLQG1meBm3NGdhb1xxmliMJOjFSktwlBx3Nyf8A5Adt/wAC/mKp6dqVzpV0txaybWHDA9GHoRVub/kB2/8AwL+YrKNc0G4u63JueuaHr9rrVtvjOyZR88RPK+/uPetmvELS9nsLpLq3kKSxnII7+x9q9otZ/tFrDNjHmIrY9MjNfS4DFuvFqW6OqnPmWpYooor0DUKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAqlqhxpV2f8Apg//AKCauVS1bjSLw/8ATB//AEE1nU+Biex4nZx+bcxR/wB5gKqTadNqGupYQkLJJKw3kcADOTj6Cr+mf8hC3/3x/Or+koD46t+O8p/Q18vhEpVVF9Tjgrsv2nw7sxg3VzcznuN20fpW3aeENGtCDHYQ7h/E43H8zXQIvFPAr6iNGnHZHYopFSOyiiXCIqj0AxUwhA7VNijFaDIHQYPFeWakMavdj/pq3869XccGvKdT/wCQzef9dm/nXj5x/Dj6mFfZGhL/AMgSD/gX86yq1Jf+QJD9WrKrwTnEY/KfpXtmlc6RZf8AXBP/AEEV4m3Q17XpH/IGsf8ArhH/AOgivZyn4pfI3obsvUUUV7p0BRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAJVHWDjRb4/wDTCT/0E1eqhrZxoV+f+neT/wBBNZ1fgfoJ7HjWmf8AIQt/98fzrR0fnxzbfSX+RrO0z/kIQf74rS0Tnxxb/wC7L/KvmMF/HXqclP4kekKOBUmKavQVj3vivSrGUxmVpnBwREMgfj0r6epWp0lebsdbklubVFZ2l69Y6uWS3dllUZMcgwceo9a0qdOpCpHmg7oE09UROODXlOqf8hm8/wCuzfzr1d+hryjVP+Qzef8AXZv515Wcfw4+pjX2Rcl/5AsX1NZea2Y4hc6AdjAyRPyncg9xWT9nmJ4jb8RXgXRzkZ6fhXtejc6JY/8AXvH/AOgivGvssmPmaNfq1dxbeN4LLT7e2WAu0MSoWL8EgAelell2JpUZSc3Y1pSUb3O7orz2Xx/cnIjgjH1BP9az5vGeqS8CbYP9kAf0r0JZtRWybNHWiepZpMg9CDXj8uvahMf3lxI31Ymrz6zdQWNvcQuI5oicMB972PqKyWbpv4dPUXt12PU6KwvD3iO31624xHcoP3kRPT3HqK3a9anUjUipRd0bJpq6FooorQYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUlV5r21tx+9uIo/95wKmUlHVsCxRWLP4o0aDO6+jJ9EJb+VZs3j/AEqL/ViaU+ygVzyxlCO8kQ5xXU6yszX3CaBfsTj/AEd/5GuUn+JAHEFifq71gax4u1DV7ZrZhHDC33lQfe+prkr5lR5HGOr9CJVY20MnTP8Aj/g/3xWjoPPjaA/9M5f5Vnab/wAf8P8AvCtDw9z40g/65S15GB/jx9TGn8SOm8U6hOv2fSrQkTXRG4g87ScAfif5VradoVhp1ssS28cjgfPI6Alj+Nc7q7i38c2M0xxHiPk9B1H867Svcw6VWtOU9WnZeS/4JvHWTbOK16O00PxBY3tqFRid0sKccdyB2yM119rdQ3trHcwNuikGVJGK4fxnZSQ6qLwgmGdAA3owGMf1rrtDt2tdDs4WGGEYJHoTz/WssHKSxNSmlaO/9eoqbfO0XH6GvKNU/wCQze/9dm/nXrD9K8n8Sxy6frVy0mFjlcujHoc0ZrTlOnHlWzCsm0QKzL0Yj6UFmPVifqayjqKE4Eu4+ijNPR7mb/VWl3J9IzXiRw05bI51BmjuA70hlRerCoI9K1mf7mlyD3kYD+tXIvCmvy9Y7aEe7E/0reOX1X0KVKRXNzGO+fpSC6UnGD+VakfgTU5P9dqCKP8AYj/+vUkvgIwQtKb+4Z1G7sB/Kt1llSxXsWZ6MGAIrQm/5BI/GsyHhcelaUnOkn6mvLMjNtbqayuUuLeVo5EOVYV6z4Y8Qpr9kxZBHcRYEqDpz0I9jzXkFdt8NT/xMb8esSH9TXpZdWlGqoJ6M1pSalY9Jooor6Q6gooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDI8Rzva+Hb+aJisiwnaw6jtXjLSu5yzsT3JNeweLzjwpqB/6Z/1FeQxRebHLgZ2oTXz2ba1Yry/U5q/xIhMijqaaZ0pNL0O71rUZoYJxHHEAXZhnGegArpofh6T/AK7UZz7IoWsqWXVKkeZbExpN6nMeeOymmtdBepVfq1dxD8PtLX/W+fL/AL8p/pWhB4M0aHBWwhJ9WXd/OuqOUvqy1RPNY9USGUMsqFh2HNdT4Ktbi71z+0DDIlvDCUDyKV3scdK7SDRrKDHl20SY/uoBWjHEEGAMCuuhl0KU1O+xcaSTuYnibRH1SzSW3GbmHO1f76nqPr6Vi6d4vurFBbX0BmEfy5J2yD2Oetd1VS90mx1Hm6tUkbs+MMPxHNOvhZup7WjLll17MJQd+aL1MceLtGuY9lxFKFzkrJEGGf1rSt9f0q6YLFexbj/C/wAp/Wsy48FaaQSk88H1YED865rVPD8lgHeG5guo0GX8thvUepXPSuSpiMZQ96aTXkS5Tjq0ekEZFUrvTre7GJ4kkHoy5rk/CutyW1wbK4dmtmVmTPJQgZ4/AHitqTxlpK/c8+T6R4/ma7aOPoVKanJ28mXGrFq7Lcej2kX+rgjX/dUCrC2ca9FFYTeNoGbZBp88jHoNwyfwGa2NLu9Qvd0lzYC0hx8oZyXY/TsK0pYqjUly03f5ManFuyLIt0HYU4RD0qfFGK6iyHyxVW9QfZpOP4T/ACq+RVW8H+jyf7ppPYDyiPgsPetB/wDkFn6ms9Pvv/vGr5/5BjfWvi5fEcBk12fw2P8AxN7wesI/9CrjK7H4cf8AIbuh62//ALMK68D/ALxAun8SPTqKKK+qOwKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooA5/xkceFL//AHVH/jwry3TxkT/9cjXqHjY48J3vvsH/AI8K8w077s5/6Zmvnc1/jL0/U5a3xGz4DQfb9VOP+ef/ALNXeBRXEeAh/pWrH/aj/ka7oV6+B/gRN6fwoTbUV1JJBbPLFA07ryI1IBb6VYApa6mrqyLOSufFl7bg50WSIDvKW/wrPfxtqLf6uG2Qf7pb+td71GD09K57WvCttfK01mqW9z1wBhH+o7fWvKxOHxajenO/lZIxnGpbRnMSeKtZk/5ewn+5Go/pVSXWdTm/1l/cEegkI/lVa4tprSdoLiJo5V6qwqMV4E69e9pyf3s5XKXVjnkkk5kkd/8AeYmtHQP+QoR/AYZQ/wDu7DmsytS3H2DSZrl+JrxTDAO+zPzt/QfjU0XJzUn01+7/ADCO9yDRuNUt27LuY/QKSa0dA8NS6qq3E5aK0HQj7z/T/GrPhHRxeNcXU6nydpiXtuJ+9+nH413SqqIqIoVVGAAOAK9fAYBVYxnU21du5tSpXSbK9np9pp8YS1gSIdyByfqepqxS0V70YqKtFWR1JWEopaKoBtVrsfuH+hq0arXX+pf6Gk9gPJh/rZP941e/5hz/AFql/wAt5f8AfNXP+Ye/1r4yXxM4DKrrvhyceILgetsf/Qlrka6z4dnHiSQets3/AKEtdOC/jx9S6fxI9Tooor6s7AooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigDmfHZx4UuvdkH/jwrzOw/1c/wDuf1r0rx6ceFZveRB/49Xmtj/qZv8Ad/rXzmafx16L9TlrfEdD4BH73VT/ANNU/ka7kVxHgAf8hQ/9Nl/9BrthXs4L+BE3p/Ch4opBS11FhRRRQBWvNPtNRj8u7gSUDoT1H0PUVxut6PomlyBPtdyJW5EKAOQPcnGK7eeYW9vLMw4jQuR9BmvPtGtE1rUrm81KbbBGPNmYtjJJ4GewrycxUOaMFFOUur6JGNW2itqyAWsFlcalvQXAtMBBJkAksBkgdfpVuw0TUdeuRc3RaKA4BkZcfKOgRf8AIqzayXMeua01lbLcTbvkRhkffHOPaq03ibXrS8ZLiQLIh+aJ4hj/AD+NeXGNGFnUvy3eiWm/VmNorfY722tobO2jt4ECRRjCgVNVawuhfWFvdBdolQNt9Ks19RDlcVy7HWttAoooqhhRRRQAhqvc/wCqb6VYNQXH+rb6UnsB5Kf+PmYf7Z/nVsf8eD/Wqr/8fc/++f51ZH/Hi/1r4yp8bOB7mZ611Xw/OPE2PW3f+a1ytdP4COPFKe8L/wBK6MJ/Hh6lQ+JHrFFFFfWHaFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAcp8QTjwu49ZU/nXm9l/x7zH2H869F+Ihx4aHvOn9a860+7it/NWWPekiFeD0PY183mj/f8AyRy1viOm8Af6nUj63A/9BFdoDXlmkanPo73AhljaOZgxUocgjitM+Lbw/wDLRR9E/wDr13YbMKEKUYyevozSFWKjZnoOR60u4etecN4qvT/y2P4IKjbxLen/AJbyfhitHmlDpf7h+2ielb19aUMD0NecWmsXF1Pslu540IPzKRxx9K1PCmtXVxqtxYXMplURCWNiORzgg/mK0o5hRrT5I3uONWMnY7GaJZ4JIX+7IhQ/QjFeaeW2kXc1hqMUhgdl3iM4LBTkEHoa9NBzXGvcvceL5dNvwktpJMVWOUZ2/L8u09RnjpWGZU4vld7O9l217k1lexBYa3p2nalfX6vPM1znbEItu3nPJzVJLe98U6xLOkWxHYb3/hjUcAZ7nFamhWdhea1fW0mnwFLcnZyxzhsc5OK7GONIowkaKiDoqjAH4Vz0MJPERXtJLlTei7/MmMHNavQS3hS2to4IhhI0CL9BUN3fwWS5mkCZ6ZqwTivMddv55tdvAZG2pIUUegFejisT9VpppX6Gs58iO3bxNp46S5+gNRnxRZ9vMP0Q/wCFee/aJf8Anq/50nnSHrIx/GvLecVOkUY+3fY78+KYO0Ux/wCAGmN4pXtbS/iBXBeYx/jP50bz6n86h5tW6JfiL20juG8UP2tW/Fh/jVS58UzCMjyVTI7sDXI7vel3CoeZ4h9l8he2mIMl2c9WOatj/jykqruHrVgMBZSEnuK88zM810XgQ48Vwe8cn8q5yuh8DnHi2190k/8AQTXThf48PVFQ+JHr1FFFfWnaFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAcf8AERWPhoMASqzoWPoMEZ/UV5V5y9q+gJI0lQpIoZGGCpGQay5fC+hzEl9KtCT6RAfyrzMXgPbz50zKdLmdzxTzh7/lSecPQ/lXsUngbw3JnOlxj/ddl/kaqS/Dnw2/S1mX/dnb+prl/smXcj2LPJ/PHvT1lDdK9O/4Vh4ezn/TPp53/wBasvxH4I0bRNCuL2zWcTJtALylhywHSs6uWyhByvsJ0mlc5KzPzt/un+Va3hD/AJGuX/r1P/oQrJs+r/7h/lWt4Q/5Gqf/AK9f/ZhXPgP94iTT+JHo4NY2u+HY9XZZ4pPJu1GA/Zh2z/jWwuT0rNu/Eel2LsklyHkU8pGNxz6elfQ4j2Lp2qtW8zpny2945/S11iO9nFnPp1xcL8su775APc4BPPeujs7+9M622o2Pku4OyWJt8bY7E/wn61xmh65Bp+sXV1cI/lXG7JUZK5bI4rsrLxBpl/L5UF0BIeiSAqT9M15+Bq03FWnZ32b/AMzKm1bc0HPBrynV/wDkO33/AF2avVXzt9q8q1b/AJDt9/12NPNv4cfUdfZFO4zFb+YMcnAB7msWTWXQkGKT8BW1qi506LH941zbBga8qjCMlqYxSZKdf9UkH1qSPV3lOESRj6CqoBJ5r3P4d2UFt4PtJY4kWSbe8jAcsdxHJ+gFdtDCwqy5S4wTZ48Lm7f7tpct9EP+FSD+0n+7p14fpE/+FfRWBRgV2/2bTNPZI+eBbay/3dIvz/2wf/CpV0/xGy7V0W/K9cGB8fyr6CwKMCq/s6mHskeBR6P4jPXQr/8A78EV13gjQNWi1yO9vbKS1hhVv9bgFiRjAHXv1r0+inDAUozU10GqSTuLRRRXeaBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAJXNePDjwndf7yf+hCulrmfHpx4TuP8AfT/0IVz4r+BL0ZM/hZ5faf8ALT/cP8q1vB4P/CTXIBwfsvX0+YVk2vST/cP8q2PB3/Iz3X/XsP8A0IV8/l/8eJy0/iR1k2gNdZ8/V9QYHqocKPyAqqPBOmjrNdH/AIEP8K6JelOFe/LCUZO8o3Olwi90c8PBelDq1yf+2g/wpw8G6QOqzn6y1v0ZpfUqH8q+4PZw7GNF4csLVleFrpGXoRcNXA6v/wAh6+/67GvVH6V5Xq//ACHr/wD66mvPzSnCnSioq2pnVSS0K1+M6fH/ALxrBdOelb97zYx/7xrHZa8yk7IxTK6pz0r3TwH/AMiXp3+6/wD6G1eJBa9s8Cf8iZp/0f8A9DavUy93qv0/yNqW50tFFFeybhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAJXL+PzjwpP8A9dE/9CrqK5X4hH/ilX/67R/zrnxf8CXoyJ/CzzK1+7L/ALhrZ8G/8jNef9e4/wDQqyNPiM8phXlpAVUe9XvDt7BpPiWf7bIIRJDsBfgbgc4r5/ANKtG5z0viPTF6U6stNe01ul3D/wB9iphrFg3S5i/76FfTcyOsv0lUxqdmek8f/fQp/wDaFsekyfnT5kBM/SvK9Y/5D9//ANdTXpjXtvg/vV/OvMdVdZNbvXQ5Uykg+teTmz/dx9TCvsiK75sYv941mEVqXX/HlF/vGs4ivGp7GCIwtez+BP8AkT7H/gf/AKG1eNgV7H4D/wCRRtPrJ/6Ga9TLX++fp/kbUviOmooor3DoCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAozSGg0AFJmkJphNAEmaTdUJJphLUAWd1G8etUyX9TUbNL2NAF/eK5T4gsD4YYZ/wCW0f8AM1rO1x2rn/FFveahos0AHIIdSemRWGJg50ZRW7RMleLR5zFK0TBlJBHQjtUz3bSuXlCOx6llBJ+tUXtdXjJB0y5IHdVBz+tRk6gn39Nux/2xP9K+aeCrdYnL7OXY0fOTvBB+MYpfNhPW1t/+/YrJN1On37S5X6wP/hTTqQX7yOv1Rh/Sj6tWXRi5JGxvt/8An0g/75pd9t/z6x/gSKxv7Xt+7qPqcUo1a2P/AC1T/vsUvZ1l3/ELSNdmg/hhAP8A10b/ABqL+In1NUl1KBujqfoRTxexHvUuNR/Fdis+po3H/HlF/vGqBqaa9ga1jUOAVJLZ4wKy5dYsozjz1ZvRPmP6VVOnN6JDSZdFev8AgRgPCVqP9uT/ANDNeIR6hLO4WCyuGB/iKbQPz5r2DwzexWehWttGHZQpJcjGSTk8fWvVy+hUhUcpK2n+RtSi07s7PeKN4rJTUFb1qZboHvXsG5o7xRuqkJwe9SCX3oAtbqM1XD+9ODUATZpaiBp4NADqWkFAoAWiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAA0lLSUANNIRT6TFAEZWk21JijFAEW2k2CpcUYoAhKD0qpfxBrbGP4hWiRVa8XMIHvUy+FgzCNqvoKabND/AAitNYgTihYt7kAdK5uV9CLGWbJD/CKYdPjPVBW19mNJ9mPpVckh2MJtJt26xKfwqF/D9i/3rWE/VBXRfZjSfZzS5ZBY5V/CWkv97T7Y/wDbIVA3gjRG66bb/gmK7AwH0pvliizEcefAeg4DHTLc/Vc1Yi8LaZAMRWUKD/ZQCuqMY2VH5dGoGCuiWy9IVH0Fbmm6fElmqhBwT/OnCMelaNmuLcD3NXTXvDRCLNB/DThar6Vc20YrcorC3A7U4QgVY20baAIRHTglSYpcUAMC04ClpQKAAUtFLQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAJRS0lABijFFFACUUtFACYqC5H7ofWrFQzj5B9aUtgKir1+lOgX9430pwXrToR87VnFaiRLijHtTqXFajGbaTaPSpMUYoAj2CqjrhyKvGqrj9431rOa0EyPb8tM21OR8tMxUWER7avWw/cj6mquKuW4/dfjVwWo0PxS4paK0GJRS0UAGKMUUUAGKKKWgAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigBKKU00mgBaKYWppJpXAkyKZLyopuTSdaTegDQKWIfMaXFLGOTSitRD6KMGkyaq4xaKTdS5ouAYquw+c1YzUTD5jSlsAzHy03FS4+Wm4qbCGYqzDxH+NQ4qeL7n41S3AfRS4oxVDEopcUYoASilxRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUANam4oopMAxSYoopAJijFFFACgUIOTRRQgH0mKKKoBqryadgUUVKAXFREfMaKKbAMcU3FFFIBcU5DgYoooAfupc0UUwFzRmiimAtFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQB//9kKZW5kc3RyZWFtCmVuZG9iago0IDAgb2JqCjw8L0ZpbHRlci9GbGF0ZURlY29kZS9MZW5ndGggOTI2Pj5zdHJlYW0KeJzNWEuP2zYQvutXDNDL5rA0X+Kjt9T2FgnQzWOFHtrkoMhcR41kObKcFv31HcqPet0VnZrOIjZAjk1yPs7wG3LIz8lPWSIU6FRBNkumWfIm4fDS/8uA4teX2nLI6mR0w4BRyO6Tq2fZH77vZ+Ai7btZAQKUNVDUMCrrOYVJA28O1WyaUc1mCIJd76XpIRpFHYcDVUqkxVIRyR5Og/Y92nlyNc6rysGLVZ27Cn7J265cuL/hB+vnSWH+CMDv77Ge9bYOQ1uENqA0C0AzQQ2ngulILKOI4KBkCOvdlaH23TMQQl8jZiyk1kTispiQZ391bb6Cu/XStXXefnJdJKayhGHJNVF8EHN6mz2HyRTGr1CYvPpKyD+x08utmrc/79quKUl7BiPz5E6ukrvBAT3fsV+NkmIWpVDvXr3idK/ey6EB2GsP4OV/IR4Y47/oC6+FP6JFgFTSaxCml6q9dFwXmxajdn1QOq4Lr6/vsakPy2KLVW3rw7JI7r+bmez9N8w9qUDRNEA8bi2L5LfoIYbj6SYvunWbR6Iwzk/huOJjNIpKTziM0REVI075WW47z78pBk/gJHCzdZWP3t6Of/ymUzpz7iq0107K1hVF2Sy+7dQfzigVgRllrnL3zaI5a0IPcbQNrVpVukXnnsxuJHbKZIDYz3+7ofgRlMqnnFPwWKTxi4A2Dy/C7fjmKYmHtpq9rfY4EjDpGLduVnbR3GOcCDwkMNnhYgdnjujXzMp5E+1eidE9iDFxq6Itlz68I4FS7hPisEH5oitn+SzWdZQTpcJQr3HPKmN9x1J5EuhF96FcxeJYQ6Q8gVMvm7ZzsUi6Zx3uroNAeLTGMsH0TAiBCEVo7MbhVwcTjjAOibaGM0FSGYbRnJLztuRDe0Biqj68EeZ/YZBClX/JlwR4ikjRtCNpCpIHWJfG3lUVJZqHMdjlqBCCEfEwHMPHmhPWWKJMPBOCR6Kooc5Xn8rFHLp86YBTHMXrOvbijVea4K3bHxZrzIii91XOfUgJqUNXhQav9jBz8DqPPgS9ZSoUW1nT5RXcumjTOEWbOAgRSuO0uABJdkg6lCkzTDNMLO2992woT75bf+i8Ay9kURBLcUVMtO+Y6QkYZDuN3zC850Qokqf3rujKL5fgd5AHl8hSdssTDKT/QW1+/BRFMdlSSuPf2169WZwwvX2U2v7wr1J9EyVG7Jv6H/95sHr8tQtHS0Y3j13+iaeXj8b+A0V9h54KZW5kc3RyZWFtCmVuZG9iagoxIDAgb2JqCjw8L1RhYnMvUy9Hcm91cDw8L1MvVHJhbnNwYXJlbmN5L1R5cGUvR3JvdXAvQ1MvRGV2aWNlUkdCPj4vQ29udGVudHMgNCAwIFIvVHlwZS9QYWdlL1Jlc291cmNlczw8L0NvbG9yU3BhY2U8PC9DUy9EZXZpY2VSR0I+Pi9Qcm9jU2V0IFsvUERGIC9UZXh0IC9JbWFnZUIgL0ltYWdlQyAvSW1hZ2VJXS9Gb250PDwvRjEgMiAwIFI+Pi9YT2JqZWN0PDwvaW1nMCAzIDAgUj4+Pj4vUGFyZW50IDUgMCBSL01lZGlhQm94WzAgMCAyNDAgNzkyXT4+CmVuZG9iago2IDAgb2JqClsxIDAgUi9YWVogMCA4MDIgMF0KZW5kb2JqCjIgMCBvYmoKPDwvU3VidHlwZS9UeXBlMS9UeXBlL0ZvbnQvQmFzZUZvbnQvSGVsdmV0aWNhL0VuY29kaW5nL1dpbkFuc2lFbmNvZGluZz4+CmVuZG9iago1IDAgb2JqCjw8L0tpZHNbMSAwIFJdL1R5cGUvUGFnZXMvQ291bnQgMS9JVFhUKDIuMS43KT4+CmVuZG9iago3IDAgb2JqCjw8L05hbWVzWyhKUl9QQUdFX0FOQ0hPUl8wXzEpIDYgMCBSXT4+CmVuZG9iago4IDAgb2JqCjw8L0Rlc3RzIDcgMCBSPj4KZW5kb2JqCjkgMCBvYmoKPDwvTmFtZXMgOCAwIFIvVHlwZS9DYXRhbG9nL1BhZ2VzIDUgMCBSL1ZpZXdlclByZWZlcmVuY2VzPDwvUHJpbnRTY2FsaW5nL0FwcERlZmF1bHQ+Pj4+CmVuZG9iagoxMCAwIG9iago8PC9Nb2REYXRlKEQ6MjAyMTAzMTAxNTUwMzktMDQnMDAnKS9DcmVhdG9yKEphc3BlclJlcG9ydHMgTGlicmFyeSB2ZXJzaW9uIDYuNS4xKS9DcmVhdGlvbkRhdGUoRDoyMDIxMDMxMDE1NTAzOS0wNCcwMCcpL1Byb2R1Y2VyKGlUZXh0IDIuMS43IGJ5IDFUM1hUKT4+CmVuZG9iagp4cmVmCjAgMTEKMDAwMDAwMDAwMCA2NTUzNSBmIAowMDAwMDA5MTEzIDAwMDAwIG4gCjAwMDAwMDk0MTIgMDAwMDAgbiAKMDAwMDAwMDAxNSAwMDAwMCBuIAowMDAwMDA4MTIwIDAwMDAwIG4gCjAwMDAwMDk1MDAgMDAwMDAgbiAKMDAwMDAwOTM3NyAwMDAwMCBuIAowMDAwMDA5NTYzIDAwMDAwIG4gCjAwMDAwMDk2MTcgMDAwMDAgbiAKMDAwMDAwOTY0OSAwMDAwMCBuIAowMDAwMDA5NzUyIDAwMDAwIG4gCnRyYWlsZXIKPDwvSW5mbyAxMCAwIFIvSUQgWzw4ZTJmYzM1ZTZkMTNmZGQzMjMxZjBmYTRiZjI3NjczMD48MTNjNTUwYzNlZDkxYjdlNzAzNzg1Y2Q1YTk1MTE5ODQ+XS9Sb290IDkgMCBSL1NpemUgMTE+PgpzdGFydHhyZWYKOTkyMAolJUVPRgo=";

      this.pdf = this.base64ToArrayBuffer(pdff);


    },


    base64ToArrayBuffer(base64) {
      var binary_string = window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
    },





    CargarRvendedor() {
      this.$axios.post(this.$hostname + this.$hName + '/services/vendedores/findAllVendedores', {
        usuario: JSON.parse(JSON.stringify(this.$user))
      }).then(res => {
        this.Rvendedor = res.data;
      });
    },

    SelctCbvendedor() {

      if (this.CotizacionBasica.vendedor == null) {
        this.CotizacionBasica.vendedor = "";
      }

      if (this.CotizacionBasica.vendedor.codigo == undefined) {
        this.alerta("Seleccione un vendedor", "error");
        this.CotizacionBasica.vendedor = "";
        return;
      }

    },


    CbFilvendedor(e) {

      if (e.target.value.length == 1) {

        if (e.target.value.charCodeAt(0) >= 97 & e.target.value.charCodeAt(0) <= 122) {



          this.RfilVendedor = "nombre"


          this.CargarRvendedor()

        } else { this.RfilVendedor = "cedula" }



        if (e.target.value.charCodeAt(0) >= 48 & e.target.value.charCodeAt(0) <= 57) {
          this.CargarRvendedor()

          this.RfilVendedor = "cedula"

        } else { this.RfilVendedor = "nombre" }

        //numero 48 a 57
        //letras 97 a 122 

      }

    },



   // Realizar una solicitud GET al servidor y devolver los datos al componente Vue.
    cargarCliente() {

      this.$axios.get(this.$hostname + this.$hName + '/clientes/findtodo/a/3', { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RCliente = res.data))

    },




   // Un método que se llama cuando un usuario selecciona un cliente de una lista desplegable.
    SelctCbCliente() {

      //console.log('Ver Cliente')
      //console.log(this.cliente)

      //   if(this.CotizacionBasica.cliente==null){

      //     this.CotizacionBasica.cliente=''
      //   }

      // if(this.CotizacionBasica.cliente.codigo== undefined){
      // this.alerta("Seleccione un cliente", "error");
      // this.CotizacionBasica.cliente=''
      // return
      // }

    },


   // Hacer una llamada API al servidor y devolver los datos al cliente.
    CbFilcliente(e) {

      if (e.target.value.length >= 0) {

        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/clientes/findtodo/" + (e.target.value === null || e.target.value.length==0 ? 'A' : e.target.value)  + "/3", { headers: this.$store.getters.GetheadersAxios }

          )
          .then(res => (this.RCliente = res.data));
      }

    },

// Un método que recibe un cliente y verifica en una lista si tiene telefono .
selectTelefonoCliente(e) {

if ( e!=null && typeof e === 'object' && e.hasOwnProperty('telefonosClientesList') && e.telefonosClientesList!=null && e.telefonosClientesList.length > 0) {
  return e.telefonosClientesList[0].telefonosClientesPK.telefono.trim()
} else { return ' ' }

},

    // Un método que se llama cuando el usuario selecciona un cliente del menú desplegable.
    ClienteSelect(e) {
console.log('ClienteSelect')
console.log(e)
      this.telefono = ''
      this.clientEmail = ""

      this.CotizacionBasica.telefono = ''
      this.CotizacionBasica.correo=''
      this.CotizacionBasica.direccion=''
      if (e != null) {
        if (e.hasOwnProperty('codigo')) {

          this.CotizacionBasica.telefono = this.selectTelefonoCliente(e)
           this.CotizacionBasica.correo= e.email
           this.CotizacionBasica.direccion=e.direccion

          //this.ObjCliente=e
          //this.clientTel='Tel.'+e.cedrnc
         // this.telefono = this.selectTelefonoCliente(e)
          // this.telefono = e.telefono
          //this.clientEmail = e.correo

        } else {

          this.telefono = ''
          this.clientEmail = ""
          this.CotizacionBasica.telefono = ''
          this.CotizacionBasica.correo=''
          this.CotizacionBasica.direccion=''

        }

      }

    },



   // Llamar a una API y obtener los datos de la API.
    cargarCaja() {
      this.$axios.get(this.$hostname + this.$hName + '/cajas/findAllActivos', { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RCaja = res.data))

    },


    // Comprobando si el usuario ha seleccionado un valor del menú desplegable. Si no, está mostrando
    // un mensaje de error.
    SelctCbCaja() {

      if (this.CotizacionBasica.caja == null) {

        this.CotizacionBasica.caja = ''
      }

      if (this.CotizacionBasica.caja.codigo == undefined) {

        this.alerta("Seleccione un caja", "error");
        this.CotizacionBasica.caja = ''
        return

      }

    },



    Exec_notif(e) {

      //console.log(e)
      this.notif = JSON.parse(JSON.stringify(e))

      //this.Elim_notif.estado = !this.Elim_notif.estado;
    },



    alertaNotf(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        //this.new();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = true;
      }
    },



    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = true;
        EventBus.$emit("loading", false);
      }
    },



   // Un método que se llama cuando el usuario hace clic en un botón.
    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      // this.filtro();
      this.CargarListTb()
    },

// Reestablece y limpia la paginacion de la tabla
    Limpiarfiltro() {

      console.log('Entrando Al actualiza_tb_ver ')
      console.log(this.acti_tb_data)

      var Pg = {
        itemsLength: this.TbPaginator.itemsLength,
        itemsPerPage: this.TbPaginator.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginator.itemsPerPage,
      }



      this.Modallfiltro = {
        activos: true,
        cliente: null,

      }

      this.ListItems = []
      this.TbTotalItem = 0
      this.TbPaginator = JSON.parse(JSON.stringify(Pg))
      this.CargarListTb()
      this.dialogFiltros = false

    },

    //restablece la paginacion de la tabla y busca los datos con los 
    //parametros designado
    BuscarFiltros() {
      var Pg = {
        itemsLength: this.TbPaginator.itemsLength,
        itemsPerPage: this.TbPaginator.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginator.itemsPerPage,
      }

      if (this.Modallfiltro.cliente != null && this.Modallfiltro.cliente.toString().length == 0) { this.Modallfiltro.cliente = null }

      this.TbPaginator = JSON.parse(JSON.stringify(Pg))
      this.CargarListTb()
      this.dialogFiltros = false

    },


    cargarPaginacionAll(e) {

      if (e.itemsPerPage == -1) { e.itemsPerPage = 15 }
      this.CargarPaginacion(e, this.Modallfiltro.cliente)
    },

   // Una función que se llama cuando el usuario hace clic en los botones de paginación.
    CargarPaginacion(e, s) {

      this.Modallfiltro.cliente = JSON.parse(JSON.stringify(s))
      console.log(s);
      console.log('Ver paginacion')
      console.log(e)

      if (e.itemsPerPage == -1) { e.itemsPerPage = 15 }
      //var pg =
      this.TbPaginator = JSON.parse(JSON.stringify(e))
      this.CargarListTb()

    },

    CargarListTb() {
      var tipo = null
      if (this.Modallfiltro.tipocliente != null) { tipo = this.Modallfiltro.tipocliente.codigo }
      var obj = this.TbPaginator.itemsPerPage + "/" + this.TbPaginator.pageStart + "/" + this.Modallfiltro.cliente + "/" + this.Modallfiltro.activos+"/false"

      this.$axios.get(this.$hostname + this.$hName + '/cotizacion/findListCotizacionPlus/' + obj, { headers: this.$store.getters.GetheadersAxios })
        .then(res => { this.ListContizacion = res.data.ListObjecto, this.TbTotalItem = res.data.TbTotalItem })
    },




    async filtro() {
      // await this.$axios
      //   .post(this.$hostname + this.$hName + "/services/tipocliente/findalltipoclientes", {
      //     usuario:JSON.parse(JSON.stringify(this.$user)) 
      //   })
      //   .then(res => {
      //     this.list = res.data;
      //   });
    }
  },

  computed: {

    ActDescBtn() {

      if (this.CotizacionBasica.secuencia > 0) {
        this.EstadoBtn = {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: true,
          eliminar: false,
          anular: false,
          imprimir: true,
          vercuenta: false,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false
        }

      }


      if (this.CotizacionBasica.secuencia <= 0) {


        this.EstadoBtn = {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: true,
          eliminar: false,
          anular: false,
          imprimir: false,
          vercuenta: false,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false
        }

      }


      if (this.CotizacionBasica.cliente == null) {
        this.disableRecalBalClient = true
      } else { this.disableRecalBalClient = false }



      if (this.CotizacionBasica.caja != null) {
        this.CotizacionBasica.sucursal = this.CotizacionBasica.caja.sucursal
      } else {
        this.CotizacionBasica.sucursal = null
      }

      // if(this.CotizacionBasica.hasOwnProperty('detalleJson')){


      // if(this.CotizacionBasica.facturasventaPK.secuencia>0){
      // this.disabledRestFacVenta=false
      // }else{this.disabledRestFacVenta=true}
      // }else{
      // this.disabledRestFacVenta=true
      // }


      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))

    }
  }





};
</script>

<style>
#ImputColorDisable {
  color: black;
}
</style>
